module.exports = __webpack_public_path__ + "static/water_nubian9-6ff254a6facee88db5730bc9dddb9717.jpg";